<template>
  <header class="header">
    <a class="logo" href="#home-section">CNS Theater Guild</a>
    <input type="checkbox" class="menu-btn" id="menu-btn" ref="menuShown" />
    <label for="menu-btn" class="menu-icon">
      <span class="nav-icon"></span>
    </label>
    <ul class="menu">
      <li>
        <a href="#cast-section" @click="closeMenu()">Cast</a>
      </li>
      <li>
        <a href="#tix-section" @click="closeMenu()">Tickets</a>
      </li>
      <li>
        <a href="#past-section" @click="closeMenu()">Past Shows</a>
      </li>
      <li>
        <a href="#contact-section" @click="closeMenu()">Contact Us</a>
      </li>
    </ul>
  </header>
  <div class="pages">
    <section class="red" id="home-section">
      <HomeVue />
      <div class="black-triangle">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
        </svg>
      </div>
    </section>
    <section class="black" id="cast-section">
      <CallbacksVue />
      <div class="red-triangle">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M892.25 114.72L0 0 0 120 1200 120 1200 0 892.25 114.72z"
            class="shape-fill"
          ></path>
        </svg>
      </div>
    </section>
    <section class="red" id="tix-section">
      <TicketsVue />
      <div class="black-triangle">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
        </svg>
      </div>
    </section>
    <section class="black" id="past-section">
      <PastShowsVue />
      <div class="red-triangle">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M892.25 114.72L0 0 0 120 1200 120 1200 0 892.25 114.72z"
            class="shape-fill"
          ></path>
        </svg>
      </div>
    </section>
    <section class="red" id="contact-section">
      <ContactUsVue />
      <div class="black-triangle">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
        </svg>
      </div>
    </section>
  </div>
</template>

<script>
import { ref } from "vue";
import HomeVue from "./views/Home.vue";
import CallbacksVue from "./views/Callbacks.vue";
import TicketsVue from "./views/Tickets.vue";
import PastShowsVue from "./views/PastShows.vue";
import ContactUsVue from "./views/ContactUs.vue";

export default {
  setup() {
    const menuShown = ref();
    const closeMenu = () => {
      menuShown.value.checked = false;
    };

    return {
      menuShown,
      closeMenu,
    };
  },

  components: {
    HomeVue,
    CallbacksVue,
    TicketsVue,
    PastShowsVue,
    ContactUsVue,
  },
};
</script>

<style>
html {
  scroll-behavior: smooth;
}

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  color: white;
  background-color: #0b0b09;
}

.header {
  background-color: #0b0b09;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  z-index: 3;
}

.header ul {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
  background-color: #0b0b09;
}

.header ul a {
  display: block;
  padding: 20px;
  border-right: 1px solid #aaa;
  text-decoration: none;
  color: white;
  cursor: pointer;
}

.header ul a:hover {
  background-color: #2b2b2a;
}

.header .logo {
  float: left;
  display: block;
  font-size: 2rem;
  text-decoration: none;
  padding: 10px 20px;
  color: white;
  cursor: pointer;
}

.header .menu {
  clear: both;
  max-height: 0;
  transition: max-height 0.2s ease-out;
}

.header .menu-icon {
  padding: 28px 20px;
  position: relative;
  float: right;
  cursor: pointer;
}

.header .menu-icon .nav-icon {
  background: white;
  display: block;
  height: 2px;
  width: 18px;
  position: relative;
  transition: background 0.2s ease-out;
}

.header .menu-icon .nav-icon::before,
.header .menu-icon .nav-icon::after {
  background: white;
  content: "";
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
}

.header .menu-icon .nav-icon::before {
  top: 5px;
}

.header .menu-icon .nav-icon::after {
  top: -5px;
}

.header .menu-btn {
  display: none;
}

.header .menu-btn:checked ~ .menu {
  max-height: 240px;
}

.header .menu-btn:checked ~ .menu-icon .nav-icon {
  background: transparent;
}

.header .menu-btn:checked ~ .menu-icon .nav-icon:before {
  top: 0;
  transform: rotate(-45deg);
}

.header .menu-btn:checked ~ .menu-icon .nav-icon:after {
  top: 0;
  transform: rotate(45deg);
}

section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
  padding: 100px 0;
}

.pages {
  padding-top: 58px;
}

.red {
  background: #d82731;
}

.black-triangle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.black-triangle svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 70px;
  transform: rotateY(180deg);
}

.black-triangle .shape-fill {
  fill: #0b0b09;
}

.red-triangle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);
}

.red-triangle svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 70px;
  transform: rotateY(180deg);
}

.red-triangle .shape-fill {
  fill: #d82731;
}

@media (min-width: 54rem) {
  .header li {
    float: left;
  }

  .header li a {
    padding: 20px 30px;
  }

  .header .menu {
    clear: none;
    float: right;
    max-height: none;
  }

  .header .menu-icon {
    display: none;
  }
}
</style>
